<template>
  <div>
    <bread-crumb path="内容管理" subPath="主题封面列表"></bread-crumb>
    <el-card>
      <el-row style="margin-bottom: 15px">
        <el-button type="primary" @click="openAddDialog">增加主题封面</el-button>
      </el-row>
      <el-table :data="list" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
        <el-table-column prop="title" label="主题封面名称" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="220">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-arrow-up" size="mini" :disabled="scope.$index === 0" @click="move(scope.$index, -1)"></el-button>
            <el-button type="primary" icon="el-icon-arrow-down" size="mini" :disabled="scope.$index === list.length - 1" @click="move(scope.$index, 1)"></el-button>
            <el-button type="danger" size="mini" @click="remove(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="param.page" :page-sizes="[10, 20, 30, 40, 50]" :page-size="param.count" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </el-card>
    <el-dialog title="增加主题封面" :visible.sync="dialogVisible" width="500px">
      <el-select v-model="selectedSpecial" filterable placeholder="请选择主题封面" style="width: 100%">
        <el-option v-for="item in availableList" :key="item.id" :label="item.title + '（ID: ' + item.id + '）'" :value="item.id"></el-option>
      </el-select>
      <span slot="footer"><el-button @click="dialogVisible = false">取消</el-button><el-button type="primary" @click="add">确定</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
export default {
  components: { 'bread-crumb': BreadCrumb },
  data () {
    return { list: [], total: 0, param: { page: 1, count: 10 }, dialogVisible: false, selectedSpecial: null, availableList: [] }
  },
  created () { this.getList() },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/special_collection/items/list', Object.assign({ special_collection_id: this.$route.query.id }, this.param))
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
      } else this.$message.error(res.msg)
    },
    async openAddDialog () {
      this.dialogVisible = true
      if (this.availableList.length) return
      const res = await this.$http.get('/admin/special/list', { page: 1, count: 1000 })
      if (res.code === 0) this.availableList = res.data.list || []
    },
    async add () {
      if (!this.selectedSpecial) return this.$message.error('请选择主题封面')
      const res = await this.$http.post('/admin/special_collection/items/add', { special_collection_id: this.$route.query.id, special_id: this.selectedSpecial })
      if (res.code === 0) { this.dialogVisible = false; this.selectedSpecial = null; this.getList() } else this.$message.error(res.msg)
    },
    async move (index, direction) {
      const current = this.list[index]
      const adjacent = this.list[index + direction]
      if (!adjacent) return
      const res = await this.$http.post('/admin/special_collection/items/sort/swap/' + current.id, { other_id: adjacent.id })
      if (res.code === 0) this.getList()
      else this.$message.error(res.msg)
    },
    remove (id) {
      this.$confirm('确定从该合集删除此主题封面？', '提示', { type: 'warning' }).then(async () => {
        const res = await this.$http.post('/admin/special_collection/items/delete/' + id)
        if (res.code === 0) this.getList()
        else this.$message.error(res.msg)
      }).catch(() => {})
    },
    handleSizeChange (size) { this.param.count = size; this.getList() },
    handleCurrentChange (page) { this.param.page = page; this.getList() }
  }
}
</script>
